import React from "react";
import { useSelector } from "react-redux";
import { Container, Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { RootState } from "../_store";
import { history } from './../_helpers/history';
import ProductsSection from "../pages_components/ProductsSection";
import { ICategory } from "../models/ICategory";

export default function ProductsPage() {
    const { categoryId } = useParams();

    history.navigate = useNavigate();
    history.location = useLocation();

    const categories = useSelector((state: RootState) => state.category.categories);
    const products = useSelector((state: RootState) => state.product.products);

    return (
        <Container className="page-container">
            <h2 className="page-container-header">Наши продукты</h2>

            {categories
                .filter(x => x.id === Number(categoryId) && x.parentId === null).map((mainCategory: ICategory) => (
                    <Row key={mainCategory.id}>
                        <h2>{mainCategory.name}</h2>

                        <ProductsSection products={products.filter(p => p.categoryId === mainCategory.id)} />

                        <p></p>

                        {categories.filter(x => x.parentId === mainCategory.id).map((s: ICategory) => (

                            <Row key={s.id}>
                                <h5>{s.name}</h5>
                                <ProductsSection products={products.filter(p => p.categoryId === s.id)} />
                            </Row>
                        ))}
                    </Row>
                ))}

        </Container>
    )
}